import { Anchor, Group, Stack, Text, GroupProps } from "@mantine/core"
import { IconAlertCircle, IconFileCheck, IconX } from "@tabler/icons-react"

import { Loader } from "@tfg/ui"

import { getIconSize } from "../../../utils/icon.utils"

import classes from "./FileListItem.module.css"

export type FileListItemProps = {
  fileName: string
  error?: string
  onRemove: () => void
  size?: "xs" | "sm" | "md" | "lg"
  iconProps?: {
    size?: number
    stroke?: number
  }
  isRemoving?: boolean
  isLoading?: boolean
} & GroupProps

export const FileListItem = ({
  fileName,
  error,
  onRemove,
  size = "xs",
  iconProps,
  isRemoving,
  isLoading,
  ...props
}: FileListItemProps) => {
  return (
    <Group
      justify="space-between"
      wrap="nowrap"
      data-error={!!error}
      p={size === "xs" ? "xs" : "sm"}
      className={classes.wrapper}
      {...props}
    >
      {!error ? (
        <Stack gap="xs" justify="center" align="center" w="100%">
          {isLoading ? (
            <Loader size={getIconSize(size)} />
          ) : (
            <Group wrap="nowrap" className={classes.success}>
              <Group miw="16px" align="center" justify="center">
                <IconFileCheck size={getIconSize(size)} {...iconProps} />
              </Group>
              <Text size={size}>{fileName}</Text>
            </Group>
          )}
        </Stack>
      ) : (
        <Group className={classes.error}>
          <IconAlertCircle
            color="var(--mantine-color-error)"
            size={getIconSize(size)}
            {...iconProps}
          />
          <Text
            size="xs"
            c="var(--mantine-color-error)"
            typeof="span"
            maw="80%"
          >
            {error}
          </Text>
        </Group>
      )}
      <Anchor
        size={size}
        onClick={(e) => {
          e.stopPropagation()
          onRemove()
        }}
        className={classes.removeButton}
      >
        {isRemoving ? (
          <Loader size={getIconSize(size)} />
        ) : (
          <IconX color="var(--mantine-color-text)" size={getIconSize(size)} />
        )}
      </Anchor>
    </Group>
  )
}
